import PostCalculator from './post-calculator';

export default class LinkedInPostCalculator extends PostCalculator {
  constructor($target, $counter) {
    super($target, $counter);

    this.type = 'linkedin';
    this.limit = 3000;
  }
}
